<template>
  <div class="dashboard">
    <b-row>
      <b-col
        cols="12"
        sm="6">
        <nt-card
          :link="{name: 'saladeaula-enrollmentId', params: {enrollmentId: lastWatchedLesson.lesson.matricula_id}}"
          header="CONTINUAR ESTUDANDO"
          icon="fa fa-graduation-cap color-secondary"
          icon-size="sm"
          icon-link
          class="mb-4">
          <template
            slot="header"
            class="background-sidebar">
            <h5
              v-if="lastWatchedLesson.enrollment.course.comportamento == 'V'"
              class="mb-0">Vestibular</h5>
            <h5
              v-else
              class="mb-0">Continuar Estudando</h5>
          </template>
          <div class="d-flex flex-column font-0-9rem">
            <span><strong>Curso:</strong> {{ lastWatchedLesson.course }}</span>
            <span><strong>Módulo:</strong> {{ lastWatchedLesson.lesson.modulo.nome }}</span>
            <span><strong>Tópico:</strong> {{ lastWatchedLesson.lesson.topic.descricao }}</span>
            <span><strong>Aula:</strong> {{ lastWatchedLesson.lesson.lesson.nome }}</span>
            <template v-if="lastWatchedLesson.enrollment.dias_conclusao > 0">
              <span><strong>Dias para conclusão:</strong> {{ lastWatchedLesson.enrollment.dias_para_conclusao_restantes }}/{{ lastWatchedLesson.enrollment.dias_conclusao }}</span>
            </template>
            <template v-else>
              <span><strong>Dias para conclusão:</strong> este curso não exige tempo para conclusão.</span>
            </template>
            <b-button
              v-if="lastWatchedLesson.enrollment.course.comportamento == 'V'"
              id="continue-last-test-button"
              :to="{name: 'provas-enrollmentId', params: { enrollmentId: lastWatchedLesson.lesson.matricula_id }}"
              variant="primary"
              class="align-self-end  mt-3">
              Acesse Sua Prova
            </b-button>
            <b-button
              v-else
              id="continue-last-lesson-button"
              :to="{name: 'saladeaula-enrollmentId', params: { enrollmentId: lastWatchedLesson.lesson.matricula_id}}"
              variant="primary"
              class="align-self-end  mt-3">
              Assistir Aula
            </b-button>
          </div>
        </nt-card>
      </b-col>
      <b-col
        cols="12"
        sm="6">
        <nt-card
          class="mb-4"
          icon="fa fa-bell color-secondary"
          icon-bg-variant="primary"
          icon-text-variant="white"
          icon-size="sm">
          <template slot="header">
            <h5 class="mb-0">Último Aviso</h5>
          </template>
          <div
            v-if="alertsSummary.mostRecentAlert"
            class="d-flex flex-column font-0-9rem">
            <h6>{{ alertsSummary.mostRecentAlert.aviso.titulo }}</h6>
            <span><strong>Enviado em:</strong> {{ alertsSummary.mostRecentAlert.aviso.data | dateFormat }}</span>
            <span><strong>Remetente:</strong> {{ alertsSummary.mostRecentAlert.aviso.usuario.nome }}</span>
            <div class="text-right mt-3">
              <b-button
                id="all-alerts-button"
                :to="{name: 'avisos'}"
                variant="primary">
                Ver Avisos
                <b-badge
                  v-show="alertsSummary.notReadAlertsCount"
                  id="alerts-count-badge"
                  variant="danger"
                  pill
                  @click.stop>{{ alertsSummary.notReadAlertsCount }}</b-badge>
              </b-button>
              <b-button
                v-if="alertsSummary.mostRecentAlert"
                id="last-alert-button"
                :to="{name: 'avisos-alertId', params: {alertId: alertsSummary.mostRecentAlert.avisos_aluno_id}}"
                variant="primary">
                Ver Último Aviso
              </b-button>
              <b-popover
                content="Avisos não lidos"
                placement="bottom"
                target="alerts-count-badge"
                triggers="hover focus"/>
            </div>
          </div>
          <div
            v-else>
            Ooops, ainda não há avisos para serem lidos.
          </div>
        </nt-card>
      </b-col>
      <b-col
        cols="12"
        sm="12">
        <nt-card
          v-if="!blockedModules.includes('eventos')"
          class="mb-4"
          icon="fa fa-play color-secondary"
          icon-bg-variant="primary"
          icon-text-variant="white"
          icon-size="sm">
          <template slot="header">
            <h5 class="mb-0">Próximo evento</h5>
          </template>
          <div
            v-if="nextEvent"
            class="d-flex flex-column font-0-9rem">
            <h6>{{ nextEvent.nome }}</h6>
            <span v-if="nextEvent.live"><strong>Ao vivo agora.</strong> Começou em {{ nextEvent.inicio | dateTimeFormat }}</span>
            <span v-else>Acontecerá no dia: <strong>{{ nextEvent.inicio | dateTimeFormat }}</strong></span>
            <span>Pervisão de duração: <strong>{{ nextEvent.previsao_duracao }} minutos</strong></span>
            <div v-html="nextEvent.descricao"/>
            <span>Disponível após evento ao vivo: <strong>{{ nextEvent.publicar_apos_evento | publicacaoEventoFormat }}</strong></span>
          </div>
          <div
            v-else>
            Ooops, não há nenhum evento agendado.
          </div>
          <div class="text-right mt-3">
            <b-button
              :to="{name: 'eventos'}"
              variant="primary">
              Ver Todos
              <b-badge
                v-show="alertsSummary.notReadAlertsCount"
                id="alerts-count-badge"
                variant="danger"
                pill
                @click.stop>{{ alertsSummary.notReadAlertsCount }}</b-badge>
            </b-button>
            <b-button
              v-if="nextEvent"
              :class="{ 'disabled': !nextEvent.live }"
              :to="{name: 'eventos-eventId', params: { eventId: nextEvent.ls_evento_id }}"
              variant="primary">
              Acessar evento
            </b-button>
          </div>
        </nt-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        v-if="false"
        cols="12"
        sm="6">
        <nt-card
          v-if="!blockedModules.includes('mensalidades')"
          :icon-bg-variant="paymentSummary.overdue.count ? 'danger' : 'info'"
          class="mb-4"
          icon="fa fa-credit-card"
          icon-text-variant="white"
          icon-size="sm">
          <template slot="header">
            <h5 class="mb-0">Resumo Financeiro</h5>
          </template>
          <div class="d-flex flex-column">
            <template v-if="paymentSummary.overdue.count">
              <p>Você possui <strong class="text-danger">{{ paymentSummary.overdue.count }}</strong> boletos vencidos</p>
              <p>Seu boleto vencido a mais tempo é do dia <strong>{{ (paymentSummary.overdue.next.dt_venc + ' 03:00:00') | dateFormat }}</strong></p>
              <div class="text-right">
                <b-button
                  :to="{name: 'mensalidades-enrollmentId', params: {enrollmentId: paymentSummary.overdue.next.matricula_id}}"
                  variant="danger">Ver mensalidades</b-button>
              </div>
            </template>
            <template v-else>
              <p>Pode ficar tranquilo que está tudo ok!</p>
              <p>Seu próximo boleto é para o dia: {{ (paymentSummary.pending.next.dt_venc + ' 03:00:00') | dateFormat }}</p>
            </template>
          </div>
        </nt-card>
      </b-col>
      <b-col
        v-if="false"
        cols="12"
        sm="6">
        <nt-card
          icon="fa fa-credit-card"
          icon-bg-variant="info"
          icon-text-variant="white"
          icon-size="sm">
          <template slot="header">
            <h5 class="mb-0">Cursos Sugeridos</h5>
          </template>
          <div class="text-center">Disponível em breve</div>
        </nt-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        v-if="false"
        cols="12"
        sm="6">
        <nt-card
          icon="fa fa-credit-card"
          icon-bg-variant="info"
          icon-text-variant="white"
          icon-size="sm">
          <template slot="header">
            <h5 class="mb-0">Fórum</h5>
          </template>
          <div class="text-center">Disponível em breve</div>
        </nt-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import breadcrumbs from '@/assets/breadcrumbs.json'
import {GChart} from 'vue-google-charts'
import {Student} from '@/services/student.js'
import NtCard from '@/components/layout/NtCard.vue'
import Tutorial from '~/common/tutorials/main'

export default {
  async asyncData ({app: { $toast }}) {
    let lastWatchedLesson = null
    let alertsSummary = null
    let paymentSummary = null
    let nextEvent = null

    await Student.dashboardData()
      .then((response) => {
        lastWatchedLesson = response.data.lastWatchedLesson
        alertsSummary = response.data.alertsSummary
        paymentSummary = response.data.paymentSummary
        nextEvent = response.data.nextEvent
      })
      .catch((error) => {
        $toast.error(error.response.message)
      })

    return {lastWatchedLesson, alertsSummary, paymentSummary, nextEvent}
  },
  tutorial: 'main',
  components: {
    NtCard
  },
  middleware: 'authenticated',
  filters: {
    dateFormat(date) {
      if(typeof date === 'string') {
        date = date.replace(/-/g, '/');
        date = new Date(date);
      }
      return new Intl.DateTimeFormat('pt-br').format(date);
    },
    dateTimeFormat(date) {
      if(typeof date === 'string') {
        date = date.replace(/-/g, '/');
        date = new Date(date);
      }
      return date.toLocaleString('pt-br');
    },
    publicacaoEventoFormat(publicar) {
      if(publicar === 'S') {
        return 'Sim';
      }
      return 'Não';
    }
  },
  data () {
    return {
      breadcrumbs: [],
      paymentInvoicesFields: [
        'parcela',
        { key: 'dt_venc', label: 'Data' },
        { key: 'status', label: 'Situação' },
        { key: 'valor_original', label: 'Valor' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      blockedModules: 'config/blockedModules'
    })
  },
  mounted: function () {
    this.breadcrumbs = this.breadcrumbs.concat(breadcrumbs.home)
    this.$store.commit('app/setPageTitle', 'Ambiente do Aluno')
  }
}
</script>

<style>
svg {
  margin: 0 auto;
}

button.green {
  background-color: #28a745 !important;
  border: none !important;
}

.alert-item:hover {
  background-color: #e7e9ec;
  cursor: pointer;
}

</style>
